import { cn } from '~/lib/cn';

export interface TitleProps {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}

export function Title({ className, children }: TitleProps) {
  return <p className={cn('text-body-sm font-bold', className)}>{children}</p>;
}

Title.displayName = 'Title';
